<template>
  <div class="white-box mt-3">
    <div class="p30">
      <div class="row">
        <div class="col-sm-12">
          <div class="row justify-content-between align-items-center mb-3">
            <div class="col-sm-6 ft-16 font-bold mb15">Summary Feedback and Complaint</div>
            <div class="col-sm-3 text-right">
              <span class="italic">Last update {{ moment().format('DD MMMM YYYY') }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-8">
              <div class="row align-items-baseline">
                <div class="col-1">Filter</div>
                <div class="col-4">
                  <FieldSelect name="periode" v-model="summary.meta.periode"
                    :options="summary?.options?.DASHBOARD_FILTER_RANGETIME" :with-label="false" />
                </div>
              </div>
              <div class="row align-items-baseline">
                <div class="col-1"></div>
                <div class="col-11">
                  <div class="row">
                    <div v-if="summary.meta.periode === 'quarterly'" class="col-3 col-xl-2">
                      <FieldSelect name="start_quarter" v-model="summary.meta.start_quarter"
                        :options="summary?.options?.LIST_QUARTER" :with-label="false" />
                    </div>
                    <div v-if="summary.meta.periode === 'monthly'" class="col-3 col-xl-2">
                      <FieldSelect name="start_monthly" v-model="summary.meta.start_month" :options="options.months"
                        :with-label="false" />
                    </div>
                    <div class="col-3 col-xl-2">
                      <FieldSelect name="start_year" v-model="summary.meta.start_year" :options="options.years"
                        :with-label="false" />
                    </div>
                    <div v-if="summary.meta.periode === 'quarterly'" class="col-3 col-xl-2">
                      <FieldSelect name="end_quarter" v-model="summary.meta.end_quarter"
                        :options="summary?.options?.LIST_QUARTER" :with-label="false" />
                    </div>
                    <div v-if="summary.meta.periode === 'monthly'" class="col-3 col-xl-2">
                      <FieldSelect name="end_monthly" v-model="summary.meta.end_month" :options="options.months"
                        :with-label="false" />
                    </div>
                    <div class="col-3 col-xl-2">
                      <FieldSelect name="end_year" v-model="summary.meta.end_year" :options="options.years"
                        :with-label="false" />
                    </div>
                  </div>
                </div>
              </div>
              <BarChart :key="JSON.stringify(summary?.data?.bar_chart)" :overlay-items="overlayItemsBarChart"
                :chart-data="chartDataBarChart" />
            </div>
            <div class="col-sm-4">
              <div class="ft-16 font-bold mb15">Summary Keluhan YTD</div>
              <PieChart :data="chartComplaintData" />
            </div>
          </div>
        </div>
        <div class="col-sm-12 mt-5">
          <div class="row justify-content-between align-items-center mb-3">
            <div class="col-sm-6 ft-16 font-bold mb15">Summary Feedback and Complaint (Outstanding)</div>
            <div class="col-sm-3">
              <FieldSelect name="periode" v-model="outstanding.query.filter_status" :options="outstanding?.status"
                :with-label="false" />
            </div>
          </div>
          <DataTable :show-header="false" :key="outstanding?.rows.length" :perpage.sync="outstanding?.query.per_page"
            :currentPage.sync="outstanding?.query.page" :total.sync="outstanding?.query.last_page"
            :rows.sync="outstanding.rows" :table-fields="DASHBOARD_SUMMARY_FNC_OUTSTANDING" :no-min-height="true">
            <template #table-body>
              <tbody>
                <template v-for="group in outstanding?.rows">
                  <tr v-for="(item, index) in group.items" :key="item.id">
                    <td v-if="index === 0" :rowspan="group.items.length">
                      {{ group.periode }}
                    </td>
                    <td>{{ item?.customer?.name }}</td>
                    <td>{{ item?.grade }}</td>
                    <td>{{ item?.lot_no }}</td>
                    <td>{{ item?.end_product_application }}</td>
                    <td>{{ item?.issue }}</td>
                    <td>
                      <div class="status"
                        :style="`background-color: ${statusBackground(item?.status?.label)}1a;color: ${statusBackground(item?.status?.label)};text-transform: Capitalize;`">
                        {{ item?.status?.label }}
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </template>
          </DataTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from '@/components/chart/bar.vue';
import PieChart from '@/components/chart/pie.vue';
import FieldSelect from '@/components/field/Select.vue';
import { DASHBOARD_FILTER_RANGETIME, LIST_QUARTER } from '@/components/form/feedback/constant.js';
import { DASHBOARD_SUMMARY_FNC_OUTSTANDING } from "@/constants/table-field.js";
import { getStatusColor, STATUS } from '@/constants/feedback-n-complaint';
import DataTable from "@/components/DataTable.vue";
import { getMonthList, getYearList } from '@/constants/options';
import moment from 'moment';

import axios from '@/axios';
import { showErrorMessage } from '@/utils';

export default {
  name: 'DashboardSummary',
  components: {
    FieldSelect,
    BarChart,
    PieChart,
    DataTable
  },
  data() {
    return {
      moment,
      summary: {
        data: {
          bar_chart: null,
          pie_chart: null,
        },
        meta: {
          periode: 'quarterly',
          start_quarter: 'Q1',
          start_year: moment().year(),
          start_month: moment().month(),
          end_quarter: 'Q4',
          end_year: moment().year(),
          end_month: moment().month()
        },
        options: {
          LIST_QUARTER,
          DASHBOARD_FILTER_RANGETIME
        }
      },
      outstanding: {
        query: {
          per_page: 10,
          page: 1,
          last_page: 0,
          filter_status: 'all'
        },
        rows: [],
        status: []
      },
      DASHBOARD_SUMMARY_FNC_OUTSTANDING
    }
  },
  async created() {
    try {
      this.$store.dispatch('toggleLoadingProgress', true)
      await Promise.all([
        this.getSummary(),
        this.getOutstandingData(),
        this.getOutstandingStatus()
      ])
    } catch (error) {
      console.error({ error })
    } finally {
      this.$store.dispatch('toggleLoadingProgress', false)
    }
  },
  methods: {
    getSummary() {
      let params = {
        periode: this.summary?.meta?.periode,
      }

      if (params.periode === 'quarterly') {
        params.start_date = `${this.summary.meta.start_quarter}-${this.summary.meta.start_year}`
        params.end_date = `${this.summary.meta.end_quarter}-${this.summary.meta.end_year}`
      } else if (params.periode === 'monthly') {
        params.start_date = `${this.summary.meta.start_month}-${this.summary.meta.start_year}`
        params.end_date = `${this.summary.meta.end_month}-${this.summary.meta.end_year}`
      } else if (params.periode === 'yearly') {
        params.start_date = this.summary.meta.start_year
        params.end_date = this.summary.meta.end_year
      }

      axios.get('/dashboard/summary_fnc_chart', {
        params
      }).then(res => {
        const { data } = res.data
        this.summary.data = data
      }).catch(err => {
        showErrorMessage(err)
      })
    },
    async getOutstandingData() {
      try {
        const response = await axios.get('/dashboard/summary_fnc', {
          params: this.outstanding?.query
        })
        this.outstanding.rows = response?.data?.data?.data
        this.outstanding.query.last_page = Number(response?.data?.data?.last_page) || 0
        this.outstanding.query.page = Number(response?.data?.data?.current_page) || 1
      } catch (error) {
        showErrorMessage(error)
      }
    },
    async getOutstandingStatus() {
      try {
        const response = await axios.get('/dashboard/status')
        this.outstanding.status = response?.data?.data.map(s => ({ text: s.label, value: s.value }))
      } catch (error) {
        showErrorMessage(error)
      }
    },
    statusBackground(status) {
      return getStatusColor(status, STATUS)
    }
  },
  computed: {
    chartComplaintData() {
      const pieChart = this.summary?.data?.pie_chart || {};
      return {
        labels: [
          'Close',
          'Outstanding Internal',
          'Outstanding Customer',
          'Outstanding Internal and Customer',
        ],
        backgroundColor: ['#27AE60', '#F4BE00', '#F47E00', '#00AFF4'],
        data: [
          pieChart.close != 0 ? pieChart?.close : null,
          pieChart.outstanding_internal != 0 ? pieChart?.outstanding_internal : null,
          pieChart.outstanding_customer != 0 ? pieChart?.outstanding_customer : null,
          pieChart.outstanding_internal_customer != 0 ? pieChart?.outstanding_internal_customer : null,
        ],
      };
    },
    // Extract bar chart data with null safety
    barChartData() {
      return this.summary?.data?.bar_chart || [];
    },
    // Simplified overlay items for bar chart
    overlayItemsBarChart() {
      return this.barChartData.flatMap(sale =>
        sale?.data?.map(item => ({
          customers: item?.customer,
          tonnage: `${item?.sale} Ton`
        })) || []
      );
    },
    // Chart dataset configuration
    chartDatasetConfig() {
      return [
        {
          label: 'Close',
          key: 'close',
          backgroundColor: '#2ecc71',
          borderRadius: 4,
          stack: 'Stack 0',
          barThickness: 33,
          data: [],
          skipNull: true
        },
        {
          label: 'Outstanding Internal',
          key: 'outstanding_internal',
          backgroundColor: '#F4AF00',
          borderRadius: 4,
          stack: 'Stack 0',
          barThickness: 33,
          data: [],
          skipNull: true
        },
        {
          label: 'Outstanding Customer',
          key: 'outstanding_customer',
          backgroundColor: '#F47E00',
          borderRadius: 4,
          stack: 'Stack 0',
          barThickness: 33,
          data: [],
          skipNull: true
        },
        {
          label: 'Outstanding Internal and Customer',
          key: 'outstanding_internal_customer',
          backgroundColor: '#00AFF4',
          borderRadius: 4,
          stack: 'Stack 0',
          barThickness: 33,
          data: [],
          skipNull: true
        },
        {
          label: 'No. of Customer',
          backgroundColor: '#2F80ED',
        }
      ];
    },
    // Generate chart labels
    chartLabels() {
      const labels = [];

      this.barChartData.forEach(sale => {
        sale?.data?.forEach(item => {
          const monthName = moment().month(sale.month - 1).format("MMM");
          labels.push(`${item?.type} - ${monthName} ${sale?.year}`);
        });
      });

      return labels;
    },

    // Generate chart datasets with data
    chartDatasets() {
      const datasets = this.chartDatasetConfig.map(config => ({ ...config, data: [] }));

      this.barChartData.forEach(sale => {
        sale?.data?.forEach(item => {
          // Find and populate each dataset
          const closeDataset = datasets.find(d => d.key === 'close');
          const outstandingInternalDataset = datasets.find(d => d.key === 'outstanding_internal');
          const outstandingCustomerDataset = datasets.find(d => d.key === 'outstanding_customer');
          const outstandingInternalCustomerDataset = datasets.find(d => d.key === 'outstanding_internal_customer');

          closeDataset?.data.push(item?.close != 0 ? item?.close : null);
          outstandingInternalDataset?.data.push(item?.outstanding_internal != 0 ? item?.outstanding_internal : null);
          outstandingCustomerDataset?.data.push(item?.outstanding_customer != 0 ? item?.outstanding_customer : null);
          outstandingInternalCustomerDataset?.data.push(item?.outstanding_internal_customer != 0 ? item?.outstanding_internal_customer : null);
        });
      });

      return datasets;
    },

    // Main chart data object
    chartDataBarChart() {
      if (!this.barChartData.length) {
        return {};
      }
      return {
        labels: this.chartLabels,
        datasets: this.chartDatasets
      };
    },
    options() {
      return {
        months: getMonthList(),
        years: getYearList()
      }
    },
  },
  watch: {
    'summary.meta': {
      handler() {
        this.getSummary()
      }, deep: true
    },
    'outstanding.query': {
      handler() {
        this.getOutstandingData()
      }, deep: true
    },
  }
}
</script>
